import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import HowItWorks from './components/HowItWorks';
import WhoUses from './components/WhoUses';
import FAQSection from './components/FAQSection';
import ArticleCTA from './components/ArticleCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.store';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: `${siteUrl}/`,
    },
  ],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Vigorbuy Spreadsheet',
  url: siteUrl,
  description: 'Smart product discovery platform with 14 curated categories including Shoes, Hoodies, T-Shirts, Jackets, Accessories and more.',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <FeatureSection />
        <HowItWorks />
        <WhoUses />
        <ArticleCTA />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}